import { Reveal, SectionLabel } from "./Reveal";

export const About = () => (
    <section id="sobre" data-testid="about-section" className="bg-white py-24 lg:py-32 overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14 items-center">
            <div className="lg:col-span-5 relative order-2 lg:order-1">
                <Reveal>
                    <div className="relative">
                        <div
                            className="absolute -top-6 -left-6 w-40 h-40 border-2 border-brand rounded-3xl pointer-events-none"
                            aria-hidden="true"
                        />
                        <img
                            data-testid="about-image"
                            src="/photos/dono-bm.jpg"
                            alt="Diego Brandão, responsável pela Brandão Morais Higienização, com uniforme da empresa e equipamento profissional"
                            className="relative rounded-3xl w-full h-[440px] sm:h-[540px] object-cover object-top"
                            loading="lazy"
                        />
                        <div className="absolute -bottom-6 -right-2 sm:-right-6 bg-navy rounded-2xl px-7 py-5">
                            <p className="text-[10px] tracking-[0.25em] uppercase font-bold text-white/50">
                                Quem atende você
                            </p>
                            <p className="font-display font-bold text-white text-lg leading-tight">
                                Diego <span className="text-brand">Brandão</span>
                            </p>
                        </div>
                    </div>
                </Reveal>
            </div>

            <div className="lg:col-span-7 order-1 lg:order-2 lg:pl-8">
                <Reveal>
                    <SectionLabel>Sobre nós</SectionLabel>
                    <h2 className="mt-5 font-display font-bold text-navy tracking-tight text-4xl sm:text-5xl leading-[1.1]">
                        Uma empresa comprometida com a{" "}
                        <span className="text-brand">qualidade</span> e o seu bem-estar.
                    </h2>
                </Reveal>
                <Reveal delay={0.12}>
                    <p className="mt-7 text-navy/70 text-base sm:text-lg leading-relaxed max-w-2xl">
                        A <strong className="text-navy">Brandão Morais Higienização</strong> é
                        especializada em serviços de higienização e limpeza profissional. Nosso
                        compromisso é oferecer um atendimento próximo, seguro e de alta qualidade,
                        cuidando de estofados, sofás, colchões e ambientes com a atenção que cada
                        cliente merece.
                    </p>
                    <p className="mt-5 text-navy/70 text-base sm:text-lg leading-relaxed max-w-2xl">
                        Trabalhamos com produtos e equipamentos adequados para cada tipo de
                        material, priorizando a saúde da sua família, a durabilidade dos seus móveis
                        e a sua total satisfação.
                    </p>
                </Reveal>
                <Reveal delay={0.2}>
                    <div
                        data-testid="about-history-highlight"
                        className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl"
                    >
                        <div className="bg-navy noise-bg rounded-2xl px-7 py-6 flex items-center gap-5">
                            <p className="font-display font-extrabold text-brand text-5xl leading-none">
                                +5
                            </p>
                            <p className="text-white/80 text-sm font-semibold leading-snug">
                                anos de atuação em higienização profissional
                            </p>
                        </div>
                        <div className="border-2 border-brand/40 bg-brand/5 rounded-2xl px-7 py-6">
                            <p className="font-display font-bold text-navy text-base leading-snug">
                                Evolução constante
                            </p>
                            <p className="mt-1.5 text-navy/60 text-sm leading-relaxed">
                                Estamos sempre buscando aperfeiçoar nossas técnicas para entregar
                                o melhor resultado em cada serviço.
                            </p>
                        </div>
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);
